import { Card, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export function ProductCatalogCardSkeleton() {
  return (
    <Card>
      <CardHeader className='flex flex-row items-center justify-between gap-4 space-y-0'>
        <Skeleton className='h-5 w-48 max-w-full' />
        <Skeleton className='size-8 shrink-0 rounded-md' />
      </CardHeader>
    </Card>
  )
}
